import type { TourAnchor } from '~/helpers/tour/anchors'
import { CircleHelp } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { Button } from '~/components/ui/button'
import { tourAnchor } from '~/helpers/tour/anchors'
import { cn } from '~/lib/utils'

type IProps = {
  /** Le centre d'aide du cadre où se trouve le bouton. */
  helpPath: string
  anchor: TourAnchor
  className?: string
}

/**
 * Le centre d'aide (#78), en vue dans le bandeau de chaque écran (#128) : il
 * n'était qu'une entrée du menu utilisateur, qu'on ne trouve qu'en cliquant sur
 * son propre nom — pas là qu'on cherche de l'aide quand on est perdu.
 * Le libellé disparaît sur téléphone ; le nom accessible, lui, reste. Absent
 * du centre d'aide lui-même, où il ne mènerait nulle part.
 */
function HelpButton({ helpPath, anchor, className }: IProps) {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  if (pathname === helpPath) return null

  return (
    <Button asChild variant="ghost" size="sm" className={cn('shrink-0', className)} {...tourAnchor(anchor)}>
      <Link to={helpPath} aria-label={t('help.title')}>
        <CircleHelp className="size-4 sm:mr-2" />
        <span className="hidden sm:inline">{t('help.title')}</span>
      </Link>
    </Button>
  )
}

export default HelpButton
